import UserData from '../Models/UserData';

const FeatureFlagService = {
  checkForVpsFeatureFlag(currentUser: UserData): boolean {
    return FeatureFlagService.checkForFeatureFlag(
      currentUser,
      'FEATURE_SCHURQ_LINKEDHELPER'
    );
  },

  checkForFeatureFlag(currentUser: UserData, featureFlag: string): boolean {
    if (!currentUser || currentUser.roles === undefined) {
      return false;
    }
    if (currentUser.roles.length === 0) {
      return false;
    }
    return currentUser.roles.includes(featureFlag);
  }
};

export default FeatureFlagService;
